import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginModuleComponent } from '../loginmodule/login-module.component';
import { SignInPageComponent } from '../loginmodule/signinpage/signinpage.component';
import { CustomerLoginComponent } from '../loginmodule/signinpage/custsigninpage.component';

const routes: Routes = [
  {
    path: '', redirectTo: 'signinpage',
    pathMatch: 'full'
  },
  {
    path: 'signinpage', component: SignInPageComponent
  },
  {
    path: 'cl', component: CustomerLoginComponent
  },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)
    ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
